import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, getFormValues, initialize, Field, reset } from 'redux-form'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { getSizesMale, cleanSelectedSizeValues } from '../../actions/sizes';
import { betweenValue } from '../Rules';

import FiledInputGroup from '../Sizes/FieldInputGroup';


const formName = 'smartSizes'

const ListWrapper = styled.div`
    text-align: center;
    margin: 10px;

    @media (max-width: 768px) {
      margin: 20px 25px 10px;
    }
`;

const FieldsWrapper = styled.div`
  display: flex;
  justify-content:space-between;
  margin: 5px auto;
  width: 65%;
  min-height: 90px;

  @media (max-width: 768px) {
    display: block;
    margin: 0;
    width: 100%;
    height: auto;
  }
`;

const ListSmart = styled.ul`
  display: flex;
  list-style-type: none;
  margin: 0 20px;
`;

const ButtonWrapper = styled.div`
  margin: 20px;
`;

class SmartSizeForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {}
  }


  getSizesMale = async () => {
    const { formValues: { sizeCollar, sizeHeight, sizeWeight } } = this.props;
    await this.props.actions.getSizesMale({ sizeCollar, sizeHeight, sizeWeight });
  }

  shouldComponentUpdate = (nextProps, nextState) => (
    /* props */
    nextProps.formSyncErrors !== this.props.formSyncErrors ||
    nextProps.valid !== this.props.valid ||
    /* state */
    nextState.showErrorModal !== this.state.showErrorModal ||
    nextProps.isMobile !== this.props.isMobile
  )

  componentDidMount = () => {
    //this.props.actions.cleanSelectedSizeValues();
    //this.props.actions.formReset();
  }

  openErrorModal = () => {
    this.setState({
      showErrorModal: true,
    });
  }

  closeErrorModal = () => {
    this.setState({
      showErrorModal: false,
    });
  }

  render() {
    const { valid } = this.props;

    return (
      <form>
        <ListWrapper>
          <ListSmart>
            <FieldsWrapper>
              <Field
                validate={[betweenValue(31, 57)]}
                name='sizeCollar'
                labelText='Обхват шеи'
                units='см'
                component={FiledInputGroup}
              />
              <Field
                validate={[betweenValue(139, 214)]}
                name='sizeHeight'
                labelText='Рост'
                units='см'
                component={FiledInputGroup}
              />
              <Field
                validate={[betweenValue(43, 178)]}
                name='sizeWeight'
                labelText='Вес'
                units={'кг'}
                component={FiledInputGroup}
              />
            </FieldsWrapper>
          </ListSmart>
          <ButtonWrapper>
            <button
              disabled={!valid}
              type="button"
              onClick={this.getSizesMale}
              className={`rit-button rit-button_theme_black rit-button_size_30em`}
            >
              Получить размеры
          </button>
          </ButtonWrapper>
        </ListWrapper>
      </form>
    );
  }
}

SmartSizeForm.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  formValues: PropTypes.object,
  initialValues: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
}

SmartSizeForm.whyDidYouRender = false;

export default connect(
  (state) => ({
    isMobile: state.ui.isMobile,
    formValues: getFormValues(formName)(state),
    initialValues: {
      sizeCollar: 0,
      sizeHeight: 0,
      sizeWeight: 0,
    },
  }),
  dispatch => ({
    actions: bindActionCreators({
      getSizesMale,
      cleanSelectedSizeValues,
      initialize,
      formReset: () => reset(formName),
    }, dispatch)
  }),
)((
  reduxForm({
    form: formName,
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: false,
    forceUnregisterOnUnmount: false,
    touchOnBlur: false,
    touchOnChange: true,
  })(SmartSizeForm))
);